import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { idToLink } from 'inside-out/managers/navManager';
import { PageHeader } from 'inside-out/components/shared/pageHeader';
import { Cards } from 'inside-out/components/shared/cards';
import { PolicyCard } from 'inside-out/components/shared/cards/policyCard';
import HeaderNSWIcon from 'inside-out/images/policy-service-development/header-nsw-yellow.svg';
import {
	innerWrapperStyle,
	sectionsStyle,
	sectionStyle,
} from 'inside-out/page-styles/policy-and-service-development/section';

import { cardSection } from 'inside-out/global-styles';

import { navigateTo } from 'inside-out/components/shared/link';
import { Pagination } from 'inside-out/components/shared/pagination';

export default class SteeringCommitteeDetailPage extends React.PureComponent {
	static propTypes = {
		pathContext: PropTypes.shape({
			pageNumber: PropTypes.number.isRequired,
			totalPages: PropTypes.number.isRequired,
		}).isRequired,
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							main_heading: PropTypes.string.isRequired,
						}),
					})
				),
			}),

			policies: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							id: PropTypes.string,
							title: PropTypes.string,
							type: PropTypes.string,
							date: PropTypes.string,
						}).isRequired,
					}).isRequired
				),
			}).isRequired,
		}).isRequired,
	};

	render() {
		const { pageNumber, totalPages } = this.props.pathContext;
		const { page, policies } = this.props.data;
		const pageSettings = page.edges[0].node;

		return (
			<React.Fragment>
				<Helmet title={pageSettings.main_heading}>
					<meta property="og:type" content="website"/>
			    <meta property="og:title" content={pageSettings.main_heading}/>
				</Helmet>

				<PageHeader
					background="#F5A81E"
					titleText={pageSettings.main_heading}
					icon={HeaderNSWIcon}
					titleTextColor="#fff"
				/>
				<div className={sectionsStyle}>
					<section className={sectionStyle()}>
						<div className={innerWrapperStyle}>
							<div className={cardSection()}>
								<Cards columns={4}>
									{policies &&
										policies.edges.map(({ node }, index) => (
											<PolicyCard
												key={index}
												href={node.attachments[0].file}
												title={node.title}
												date={node.date}
											/>
										))}
								</Cards>
							</div>
						</div>
					</section>

					{totalPages !== 1 && (
						<Pagination
							initialPage={pageNumber}
							pageCount={totalPages}
							onPageChange={page => {
								navigateTo(
									page === 1
										? `/policy-and-service-development/steering-committee`
										: `/policy-and-service-development/steering-committee/${page}`
								);
							}}
						/>
					)}
				</div>
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query SteeringCommitteePolicyPage($skip: Int, $limit: Int) {
		page: allContentJson(
			filter: {
				id: { regex: "/content\\/policy-and-service-development-steering-committee-page\\.json/" }
			}
		) {
			edges {
				node {
					main_heading
				}
			}
		}

		policies: allPolicyAndServiceDevelopmentJson(
			filter: { type: { eq: "steering-committee" } }
			sort: { order: DESC, fields: [date] }
			skip: $skip
			limit: $limit
		) {
			edges {
				node {
					id
					title
					date
					attachments {
						file
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/policy-and-service-development/steering-committee.js